module.exports = __webpack_public_path__ + "img/vuma-core-banner.7549fdf1.jpg";